module.exports = __webpack_public_path__ + "static/media/404.dee0c186.svg";